import React, { Component, Fragment } from "react";
import { BrowserRouter as Router, Route } from "react-router-dom";
import Header from "./Header";
import Overview from "./overview/Overview";
import CheckIn from "./checkIn/CheckIn";
import Login from "./Login";
import { inject, observer } from "mobx-react";
import SVGSymbols from './SVGIcons';
import Cookies from "js-cookie";

@inject("UserStore")
@observer
class App extends Component {
  state = {
    loading: true
  };

  componentDidMount() {
    const { UserStore } = this.props;
    if (Cookies.get("token")) {
      UserStore.authedUser = Cookies.get("token");
    }
    this.setState({ loading: false });
  }

  render() {
    const { UserStore } = this.props;
    if (this.state.loading) {
      return <div />
    }

    return (
      <div className="App">
        <Router>
          <Fragment>
            <SVGSymbols />
            {UserStore.authedUser && <Header />}
            {!UserStore.authedUser
              ? <Route exact path="/" component={Login} />
              : <Fragment>
                  <Route exact path="/" component={Overview} />
                  <Route exact path="/check-in" component={CheckIn} />
                  <Route exact path="/check-in/:id" component={CheckIn} />
                </Fragment>}
          </Fragment>
        </Router>
      </div>
    );
  }
}

export default App;


// WEBPACK FOOTER //
// ./src/components/App.js